import { inject, Injectable } from '@angular/core'
import { Store } from '@ngrx/store'
import { Observable, map, shareReplay, switchMap, filter, combineLatest } from 'rxjs'
import { SubscriptionsService, PlanView } from './subscriptions'
import { selectUser, selectSubscription } from '../store/auth/auth.state'

@Injectable({ providedIn: 'root' })
export class ModuleAccessService {
  private store = inject(Store)
  private subscriptionsService = inject(SubscriptionsService)

  private moduleNames$: Observable<Set<string>> = combineLatest([
    this.store.select(selectUser).pipe(filter(user => !!user?.businessId)),
    this.store.select(selectSubscription).pipe(filter(sub => !!sub?.planId))
  ]).pipe(
    switchMap(([user, subscription]) =>
      this.subscriptionsService.getPlansForBusiness(user!.businessId).pipe(
        map(response => {
          const names = new Set<string>()

          // Find ONLY the purchased plan, not all plans
          const allPlans: PlanView[] = [
            ...(response.monthlyPlans ?? []),
            ...(response.yearlyPlans ?? [])
          ]

          const purchasedPlan = allPlans.find(p => p.id === subscription!.planId)

          // console.log('Purchased plan:', purchasedPlan?.name)
          // console.log('Subscription planId:', subscription!.planId)

          if (purchasedPlan) {
            purchasedPlan.modules?.forEach(m => {
              if (m.module?.name) names.add(m.module.name)
            })
          }

          // console.log('Purchased plan modules:', [...names])
          return names
        })
      )
    ),
    shareReplay(1)
  )

  hasModule(moduleName: string): Observable<boolean> {
    return this.moduleNames$.pipe(map((names: Set<string>) => names.has(moduleName)))
  }
}
